import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, map } from 'rxjs';
import { AssignedStatusType } from 'src/app/interface/trip.interface';
import { environment } from 'src/environments/environment.development';
import { PaymentService } from '../payment/payment.service';

enum APIEnum {
  GET_FARE_BREAKDOWN = 'get_fare_breakdown',
  GET_SERVICE_DETAILS = 'payments/get_service_details',
  GET_TRIP_COORDINATES = 'payment/get_trip_coordinates',
  SEND_PAYMENT_LINK = 'payments/send_payment_link',
  GET_NOTES = 'notes/fetch',
  ADD_NOTE = 'notes/add'
}

@Injectable({
  providedIn: 'root'
})
export class TripService {

  constructor(private http: HttpClient, private paymentService: PaymentService) { }


  fareEstimate: BehaviorSubject<any> = new BehaviorSubject<any>({});
  trip: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  linkExpired: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  refetchSubject: Subject<{silent: boolean}> = new Subject<{silent: boolean}>();
  tripDetail: any;


  get_fare_breakdown () {

    return this.http.post(environment.baseUrl + APIEnum.GET_FARE_BREAKDOWN, { token: this.paymentService.token })
    .pipe(map((breakdown: any) => {
      this.fareEstimate.next(breakdown?.fare_estimate);
      return breakdown;
    }));
  }

  get_info () {

    return this.http.get(environment.baseUrl + APIEnum.GET_SERVICE_DETAILS, {params: { token: this.paymentService.token }})
    .pipe(map((trip: any) => {
      console.log("TRIP", trip);
      if(trip?.flag === 6002) {
        this.linkExpired.next(true);
      } else {
        this.trip.next(trip?.data);
        this.tripDetail = trip?.data;

      }
      this.linkExpired.next(false);

      return trip;
    }));
  }

  get_trip_history(payload: { mas_trip_id: any, token: string } | { driver_id: number; start_date: Date | string; end_date: Date | string, token: string }) {
    return this.http.post(environment.baseUrl + APIEnum.GET_TRIP_COORDINATES, payload);
}

  get_assigned_status(trip: any): AssignedStatusType {
    if (trip?.ride_status === 4) {
        return 'completed';
    }

    if (trip?.ride_status === 5 || trip?.ride_status === 11) {
        return 'cancelled';
    }

    if (trip?.ride_status === 7) {
        return 'no show';
    }

    if (trip?.ride_status === 3) {
        return 'dispatched';
    }

    if (!trip?.driver_id && !trip?.declined_driver) {
        return 'pending';
    } else if (trip?.declined_driver) {
        return 'declined';
    } else if (trip?.driver_id) {
        return 'confirmed';
    }
    return 'pending';
  }

  send_payment_link(payload: { mobile: string, email?: string }) {
    return this.http.post(environment.baseUrl + APIEnum.SEND_PAYMENT_LINK, {
      request_id: this.tripDetail?.request_id,
      mobile: payload.mobile,
      email: payload.email,
      type: 'info_and_payment'
    });
  }

  getNotes(): Observable<any> {
    const url = environment.baseUrl + APIEnum.GET_NOTES;
    const headers = new HttpHeaders({
      'accept': 'application/json;charset=utf-8',
      'Authorization': `Bearer ${this.paymentService.token}`,
    });
    const userId = (this.tripDetail?.pra_user_id || "").replace(/^R/, "");
    const params = new HttpParams({
      fromObject: {
        page: 1,
        limit: 100,
        user_id: this.tripDetail?.createdby_detail.user_id,
        request_id: this.tripDetail?.request_id,
        note_type: 'request'
      }
    });

    return this.http.get(url, { headers, params });
  }

  addNote(description: string, user_id: string) {
    const url = environment.baseUrl + APIEnum.ADD_NOTE;
    const headers = new HttpHeaders({
      'accept': 'application/json;charset=utf-8',
      'Authorization': `Bearer ${this.paymentService.token}`,
      'Content-Type': 'application/json;charset=utf-8'
    });
    const userId = (this.tripDetail?.pra_user_id || "").replace(/^R/, "");

    const payload = {
      title: "test",
      description: description,
      priority: "test",
      type: "request",
      request_id: this.tripDetail?.request_id,
      user_id: user_id

    };

    return this.http.post(url, payload, { headers }).pipe(
      map((response: any) => {
        console.log("Note Added:", response);
        return response;
      })
    );
  }

}
